import { render, staticRenderFns } from "./SignupPackagesChappell.vue?vue&type=template&id=3a8be172"
import script from "./SignupPackagesChappell.vue?vue&type=script&lang=js"
export * from "./SignupPackagesChappell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports